'use client'

import { useState } from 'react'

import { Play } from '@doist/icons/brand'
import { Box, Image, OverlayButton } from '@doist/marketist'

import { TwoColumnsProps } from 'app/components/custom-page/types'
import { addProtocol } from 'app/services/contentful/add-protocol-to-url'
import { YouTubeVideo } from 'components/YouTubeVideo/YouTubeVideo'
import { useTranslation } from 'next-i18next'

import css from './two-columns.module.css'

export function VideoColumn({
    image,
    youtubeId,
}: {
    image: NonNullable<TwoColumnsProps['fields']['image']>
    youtubeId: NonNullable<TwoColumnsProps['fields']['youtubeId']>
}) {
    const [hasUserInitiatedPlayback, setHasUserInitiatedPlayback] = useState(false)
    const { t: tProductUI } = useTranslation('productui')

    return (
        <Box className={css.right}>
            <Box className={css.videoWrapper}>
                {!hasUserInitiatedPlayback ? (
                    <>
                        {image.fields.file ? (
                            <Image
                                src={addProtocol(image.fields.file.url)}
                                alt={image.fields.description}
                                className={css.videoThumbnail}
                                width={(image.fields.file.details.image?.width ?? 1264) / 2}
                                height={(image.fields.file.details.image?.height ?? 794) / 2}
                            />
                        ) : null}
                        <OverlayButton
                            startIcon={Play}
                            aria-label={tProductUI('play')}
                            onClick={() => setHasUserInitiatedPlayback(true)}
                            className={css.overlayButton}
                        >
                            {tProductUI('play')}
                        </OverlayButton>
                    </>
                ) : (
                    <YouTubeVideo
                        className={css.video}
                        videoID={youtubeId}
                        playerVars={{
                            loop: 0,
                            autoplay: 1,
                            playsinline: 1,
                            mute: 0,
                        }}
                    />
                )}
            </Box>
        </Box>
    )
}
